import { useEffect, useState, Fragment } from 'react'
import { useParams } from 'react-router-dom'
import { getProductionPlanById } from '../../api/productionPlanApi'
import Button from '../../components/Button'
import { Dialog, Transition } from '@headlessui/react'
import Input from '../../components/Input'
import { getRollByUpc } from '../../api/rollApi'
import { toast } from 'react-toastify'
import { addCut, deleteCut, getAllCuts } from '../../api/cutApi'
import { FaMinus } from "react-icons/fa6";
import ProductLabel from '../../components/product/ProductLabel'
import { formatNumber } from '../../utils/functions'

const PlanShipment = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { planId } = useParams()
    const [plan, setPlan] = useState({
        operation: null,
        inputDetails: [],
        outputDetail: null
    })
    const [isOpenCutModal, setIsOpenCutModal] = useState(false)
    const [upc, setUpc] = useState(100000000001)
    const [roll, setRoll] = useState()
    const [quantity, setQuantity] = useState("")
    const [cuts, setCuts] = useState([])

    useEffect(() => {
        getProductionPlanById(planId)
            .then(res => {
                setPlan(res.data)
            })
        getAllCuts({ productionPlanId: planId })
            .then(res => {
                setCuts(res.data)
            })
    }, [planId])

    const onClickAddCut = () => {
        const body = {
            rollId: roll?.id,
            quantity,
            productionPlanId: planId
        }
        addCut(body)
            .then(res => {
                setCuts(prevState => ([...prevState, res.data]))
                setRoll()
                setIsOpenCutModal(false)
            })
        setIsOpenCutModal(false)
    }

    const onClickGetRoll = () => {
        getRollByUpc(upc)
            .then(res => {
                setRoll(res.data)
            }).catch(err => {
                toast.error('Ürün bulunamadı')
            })
    }

    const onClickDeleteCut = (id) => {
        deleteCut(id)
            .then(res => {
                setCuts(prevState => prevState.filter(c => c.id !== id))
                toast.success('Silindi')
            }).catch(err => {

            })
    }

    return (
        <div>
            <div>
                <label className='text-xl'> Sevkiyat</label>
            </div>
            <div className='grid grid-cols-2'>
                <div className='col-span-1 border-e pe-5'>
                    <label className='block mb-5'> İşlem : {plan.operation?.name}</label>
                    <div className='mb-5'>
                        <label>Gidecek Ürünler:</label>
                        {
                            plan.inputDetails.map((inputDetail, index) => (
                                <div key={index} className='flex justify-between py-1'>
                                    <div className='flex gap-x-2 text-sm'>
                                        <label>{index + 1}. </label>
                                        <ProductLabel state={inputDetail.product} />
                                    </div>
                                    <label> {formatNumber(inputDetail.quantity)} m</label>
                                </div>
                            ))
                        }
                        <div className='flex justify-between py-1'>
                            <label>Toplam:</label>
                            <label> {formatNumber(plan.inputDetails.reduce((a, c) => a + c.quantity, 0))} m</label>
                        </div>

                    </div>
                    <div>
                        <label>Beklenen Ürün:</label>
                        <div className='flex justify-between py-1'>
                            <div className='flex gap-x-2 text-sm'>
                                <ProductLabel state={plan.outputDetail?.product} />
                            </div>
                            <label> {formatNumber(plan.outputDetail?.quantity)} m</label>
                        </div>
                    </div>
                </div>
                <div className='col-span-1 pl-5'>
                    <div className='mb-5'>
                        <div className='border-b border-zinc-600'>
                            <label>Gönderilen Ürünler:</label>
                            {
                                cuts.map((cut, index) => (
                                    <div key={index} className='flex justify-between py-1'>
                                        <div className='flex gap-x-2 text-sm'>
                                            <label>{index + 1}. </label>
                                            <ProductLabel state={cut.roll.product} />
                                            {cut.roll.boilerCode ? "Kazan no: " + cut.roll.boilerCode : ""}
                                        </div>
                                        <div className='flex items-center gap-x-5'>
                                            <label> {cut.quantity} m</label>
                                            <FaMinus className='hover:scale-125 cursor-pointer duration-150 hover:text-red-600' onClick={() => onClickDeleteCut(cut.id)} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='flex justify-between'>
                            <label>Toplam </label>
                            <label>{cuts.reduce((a, c) => a + c.quantity, 0)} m</label>
                        </div>

                    </div>
                    <Button
                        text='Ekle'
                        variant='blue'
                        onClick={() => setIsOpenCutModal(true)}
                    />
                </div>

            </div>

            {/* CUT SUBMIT */}
            <Transition appear show={isOpenCutModal} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => setIsOpenCutModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >

                                    </Dialog.Title>

                                    <div className='flex gap-x-5 mb-3'>
                                        <input
                                            type='number'
                                            className='w-full px-2 py-1 border border-2 border-zinc-600 rounded-md'
                                            label='Barkod Numarası'
                                            placeholder='Barkod numarası girin...'
                                            value={upc}
                                            onChange={e => setUpc(e.target.value)}
                                        />
                                        <Button
                                            text='Ara'
                                            variant='blue'
                                            onClick={onClickGetRoll}
                                        />
                                    </div>
                                    {
                                        roll &&
                                        <div className='mb-3'>
                                            <label className='block'>  Ürün Adı : {roll.product.collectionName}</label>
                                            <label className='block'>  Ürün Kodu : {roll.product.collectionCode}</label>
                                            <label className='block'>  Renk Adı: {roll.product.color?.name}</label>
                                            <label className='block'>  Renk Kodu: {roll.product.color?.code}</label>
                                            <label className='block'>  Desen Adı: {roll.product.pattern?.name}</label>
                                            <label className='block'>  Desen Kodu: {roll.product.pattern?.code}</label>
                                            <label className='block'>  Gramaj Adı: {roll.product.weight?.name}</label>
                                            <label className='block'>  Gramaj Kodu: {roll.product.weight?.code}</label>
                                            <label className='block'>  Miktar: {roll.quantity} m</label>
                                            <label className='block'>  Kalan Miktar: {roll.restQuantity} m</label>
                                            <label className='block'>  Kazan No: {roll.boilerCode} m</label>
                                        </div>
                                    }
                                    <Input
                                        label='Miktar (m)'
                                        placeholder='Eklemek istediğiniz miktarı girin'
                                        onChange={e => setQuantity(e.target.value)}
                                        value={quantity}
                                        type='number'

                                    />

                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-emerald-100 px-4 py-2 text-sm font-medium text-emerald-900 hover:bg-emerald-200"
                                            onClick={onClickAddCut}
                                            disabled={!roll || !quantity}
                                        >
                                            Kaydet
                                            {/* {pendingApiCall && <Spinner />} */}
                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenCutModal(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div >
    )
}

export default PlanShipment